import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SharedService } from 'src/app/shareModule/services/shared.service';
// import { Router } from '@angular/router';



@Component({
  selector: 'app-feedbacks-card',
  templateUrl: './feedbacks-card.component.html',
  styleUrls: ['./feedbacks-card.component.scss']
})
export class FeedbacksCardComponent implements OnInit {

  @Output() onAdded = new EventEmitter<{}>();

  admins = [];
  feedbackArr = [];
  selectedTitle: string;
  selected: any;
  selectedAdmin: any;
  isLogin = 0;
  public stars: any[] = new Array(5);
  currentRate: any = 0;
  feedbackStatus: any = 1;
  showFiveStarSection: number = 0;
  showFiveStarSectionNew: number = 0;
  showNotFiveStarSection: number = 0;
  feedbackStar: any;
  fetchedIpAddress: any;
  current_url: any;
  url_version: any = 0;
  private modalRef;
  name_form: FormGroup;
  submitted = false;
  show_add_name_btn = 0;
  url_names: any;
  urldata: number = 0;
  reviewLink: any;
  optional: Number = 0
  sowdescription: any;
  feedback: any;
  fivestar: any;
  feedbackManagerId: any;
  show_review_link = 0;
  show_whatsapp_link = 0;
  isSkip: any = 0;

  constructor(private sharedService: SharedService, private auth: AuthServiceService, private toaster: ToastrService, private local: LocalServiceService, private http: HttpClient, private route: ActivatedRoute, private modalService: NgbModal, private fb: FormBuilder, private router: Router) { }

  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {

      this.route.params.subscribe((res: any) => {
        if (this.router.url == `/feedbacks/${res.id}`) {
          // this.urldata = 1
          this.route.params.subscribe((res: any) => {
            this.current_url = res.id;
            this.getFeedback(this.current_url);
            this.get_feedback_manager_url_data(this.current_url);
          })
        }
      });

      // this.reloadPageOnce();
      this.getAdmins();
      // this.getIpAddress();
      // this.checkLastIpFeedback();
      if (this.sharedService.isBrowser()) {
        let href = window.location.href;

        if (href.includes('feedback-url')) {
          this.show_add_name_btn = 1;
          this.optional = 0
        }

        if (!href.includes('feedback-url')) {
          this.getIpAddress();
        }
      }

      this.route.params.subscribe(async (res: any) => {
        this.current_url = res.id;
        this.get_added_names(this.current_url);
        await this.feedbackManager(this.current_url);

      })

      this.name_form = this.fb.group({
        name: ["", [Validators.required]]
      });
    }
  }


  get nameV() { return this.name_form.controls; }

  cancel() { this.selectedTitle = null; this.selected = null; }

  ratingHover(data) {
    let href = window.location.href;
    if (href.includes('feedbacks')) {
      if (data == 5) {
        this.optional = 1
      } else {
        this.optional = 0
      }
    }
  }

  changeTemp(id, value) { this.selectedAdmin = value.id; }

  get_feedback_manager_url_data(url) {
    this.auth.get_feedback_manager_url_data(url).subscribe((response: any) => {
      this.isSkip = response.body.isSkip;
    }, (error) => {
      if (error.status == 401) {
        //
      }
    });
  }

  feedbackManager(url) {
    let formData = new FormData();
    formData.append('urlName', url);
    this.auth.feedbackManagerdata(formData).subscribe((response: any) => {
    }, (e) => {
      // return this.toaster.error(e.error.message);
    })
  }

  optionalName(data) {
    data == 1 ? this.optional = 0 : this.optional = 1
    this.optionaldata(this.optional)
  }


  optionaldata(data) {
    let newData = {
      // optional: data,
      urlid: this.feedbackManagerId
    }

    this.auth.optional_url(newData).subscribe((response: any) => {
      response
    }, (e) => {
      return this.toaster.error(e.error.message);
    })

  }

  sendTempSubadmin() {

    // if (this.selected == null) { this.toaster.error('Please enter feedback'); return }

    if (this.optional == 0 && this.selectedAdmin == null) { this.toaster.error('Please choose atleast one name.'); return }

    if (this.currentRate == 0) { this.toaster.error('Please give rating'); return }

    this.feedbackStatus = 0;

    const formData = new FormData();

    formData.append('feedbackNameId', this.selectedAdmin || 0);
    formData.append('adminId', '0');
    formData.append('description', this.selected || "");
    formData.append('star', this.currentRate);
    formData.append('ip', '');
    formData.append('module', this.current_url);

    this.auth.add_feedback_subadmin(formData).subscribe((response: any) => {
      this.toaster.success('Feedback submitted successfully');

      if (this.currentRate == 5) {
        if (this.url_version == 1) {
          //----------------------version 2 (new version)--------------------
          this.showFiveStarSectionNew = 1;
          // this.five_star_section_new();
        } else {
          //----------------------version 1 (old version)--------------------
          this.showFiveStarSection = 1;
          // this.five_star_section();
        }
      } else {
        this.showFiveStarSectionNew = 0;
        this.showFiveStarSection = 0;
        this.showNotFiveStarSection = 1;
      }

      this.selectedTitle = null;
      this.selected = null;
      this.selectedAdmin = null;
      this.currentRate = 0;
      this.feedbackStatus = 0;
      this.feedbackArr = response.body;

      // this.onAdded.emit(this.feedbackArr)

    }, (e) => {
      this.toaster.error(e.error.message);
    })

  }




  async sendTemp() {

    if (this.currentRate == 0) { this.toaster.error('Please give rating.'); return }
    if (this.currentRate < 5 && this.selected && this.selected.trim().length == 0 || this.currentRate < 5 && this.selected == undefined) { this.toaster.error('Please add feedback.'); return }
    this.feedbackStatus = 0;
    fetch('https://api.ipify.org/?format=json')
      .then((resp) => resp.json())
      .then((resp: any) => {
        this.fetchedIpAddress = resp.ip;
        if (this.fetchedIpAddress.trim().match(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/) == null) {
          return this.toaster.error('Something went wrong (add).');
        }
        const formData = new FormData();
        // formData.append('feedbackNameId', this.selectedAdmin);
        formData.append('adminId', '0');
        if (this.selectedAdmin)
          formData.append('name', this.selectedTitle);
        formData.append('description', this.selected || "");
        formData.append('star', this.currentRate);
        formData.append('ip', this.fetchedIpAddress);
        formData.append('module', this.current_url);
        this.auth.add_feedback(formData).subscribe((response: any) => {
          this.toaster.success('Feedback submitted successfully');

          if (this.currentRate == 5) {
            if (this.url_version == 1) {
              //----------------------version 2 (new version)--------------------
              this.showFiveStarSectionNew = 1;
              // this.five_star_section_new();
            } else {
              //----------------------version 1 (old version)--------------------
              this.showFiveStarSection = 1;
              // this.five_star_section();
            }
            if (this.isSkip == 1) {
              window.open(this.reviewLink.review_link, '_blank');
            }
          } else {
            this.showNotFiveStarSection = 1;
          }

          this.selectedTitle = null;
          this.selected = null;
          this.selectedAdmin = null;
          this.currentRate = 0;
          this.feedbackStatus = 0;
          this.feedbackArr = response.body;

        }, (e) => {
          this.toaster.error(e.error.message);
        })
      })
      .catch((e) => {

        console.log(e.message)
        return this.toaster.error(e.message);
      })


  }


  getAdmins() {
    this.auth.getAllSubadmins().subscribe((response: any) => {
      let array2 = [1, 36, 37, 39, 40, 41, 42, 28, 60, 61, 55, 67, 64];  //hide these admins as per requirement
      array2.push(62, 63, 68);
      this.admins = response.body.filter(e => !array2.includes(e.id));

    })
  }

  getIpAddress() {
    this.http.get("https://api.ipify.org?format=json").subscribe((res: any) => {
      // let Ip  = {'ip':res.ip};
      // this.local.saveCurrentIp(Ip);
      // this.checkLastIpFeedback();

      this.fetchedIpAddress = res.ip;

      this.checkLastIpFeedback();
    }, (e) => {
      // return this.toaster.error(e.message);
    });

    // this.auth.get_ip_address().subscribe((response: any) => {
    // }, (e) => {
    //   return this.toaster.error(e.error.message);
    // })
  }

  checkLastIpFeedback() {
    // let ip = this.local.getMyIp();
    // ip = ip.ip;

    if (this.fetchedIpAddress.trim().match(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/) == null) {
      return this.toaster.error('Something went wrong (check).');
    }

    let formData = new FormData();
    formData.append('ip', this.fetchedIpAddress);
    formData.append('current_url', this.current_url);

    this.auth.checkLastIpFeedback(formData).subscribe((response: any) => {
      this.feedbackStatus = response.body.status;
      this.feedbackStar = response.body.star;
      this.url_version = response.body.version;
      this.sowdescription = response.body.description
    }, (e) => {
      return this.toaster.error(e.error.message);
    })
  }

  five_star_section() {
    document.getElementById("five_star_section").scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  five_star_section_new() {
    document.getElementById("five_star_section_new").scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  reloadPageOnce() {
    if (!localStorage.getItem('foo')) {
      localStorage.setItem('foo', 'no reload')
      location.reload()
    } else {
      localStorage.removeItem('foo')
    }
  }

  open_add_name_modal(modal) {
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'v2_login_model' });
  }


  add_name() {
    this.submitted = true;
    if (this.name_form.invalid) { return false; }
    let formData = new FormData();
    formData.append('urlName', this.current_url);
    formData.append('name', this.name_form.value.name);
    this.auth.add_feedback_url_name(formData).subscribe((response: any) => {
      this.toaster.success(response.message);
      this.name_form.reset();
      this.submitted = false;
      this.modalService.dismissAll();
      this.get_added_names(this.current_url);
    }, (e) => {
      return this.toaster.error(e.error.message);
    });
  }

  get_added_names(url) {
    let formData = new FormData();
    formData.append('urlName', url);
    this.auth.get_feedback_url_name(formData).subscribe((response: any) => {
      this.url_names = response.body.names;
      this.reviewLink = response.body.feedbackManagerData;
      this.feedbackManagerId = response.body.feedbackManagerData.id;
      this.show_review_link = response.body.feedbackManagerData.show_review_link;
      this.show_whatsapp_link = response.body.feedbackManagerData.show_whatsapp_link;
      if (response.body.feedbackManagerData.optional == 0) {
        this.optional = 0
      } else {
        this.optional = 1
      }
    }, (e) => {
      // return this.toaster.error(e.error.message);
    })
  }

  delete_name(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to delete the name!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        this.auth.delete_feedback_url_name(id).subscribe((response: any) => {
          this.toaster.success(response.message);
          this.get_added_names(this.current_url);
        })
      }
    });
  }
  async getFeedback(url) {
    await this.auth.get_all_feedback(url).subscribe((response: any) => {
      (response)
        ? this.feedback = response.body
        : this.feedback = [];
      this.fivestar = response.body[0]?.star
      // if (this.fivestar == 5) {
      //   this.optional = 1
      // } else {
      //   this.optional = 0
      // }

    })
  }
}
